var map = {
	"./Абай облысы.png": "2da0",
	"./Алматы облысы.png": "1a56",
	"./Алматы қ..png": "4243",
	"./Астана қ..png": "511f",
	"./Атырау облысы.png": "71ac",
	"./Ақмола облысы.png": "6448",
	"./Ақтөбе облысы.png": "52eb",
	"./Батыс Қазақстан облысы.png": "b253",
	"./Жамбыл облысы.png": "6052",
	"./Жетісу облысы.png": "c316",
	"./Маңғыстау облысы.png": "aabc",
	"./Оңтүстік Қазақстан облысы.png": "09d8",
	"./Павлодар облысы.png": "1f99",
	"./Солтүстік Қазақстан облысы.png": "d420",
	"./Түркістан облысы.png": "35da",
	"./Шымкент қ..png": "1f41",
	"./Шығыс Қазақстан облысы.png": "08d7",
	"./Қарағанды облысы.png": "9739",
	"./Қостанай облысы.png": "275a",
	"./Қызылорда облысы.png": "fd68",
	"./Ұлытау облысы.png": "24aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d83";